module.exports = __webpack_public_path__ + "img/Bg-Element_fished.b302851d.svg";